<template>
  <div class="yk-qw-content-addOrEdit yk-qw-content-new-addOrEdit">
    <div class="yk-come-back-btn-wrapper">
      <!-- <el-button size="small"
                 type="primary"
                 @click="backtoclass"
                 class="yk-btn-new yk-btn-new-back-s"
                 icon="wl-icon-fanhui"></el-button> -->
    </div>
    <div class="clearfix tea-quesiton-ware-content-addOrEdit">
      <div style="width:241px;background-color:#fff"
           class="tea-question-side-wrapper">
        <div class="yk-el-aside">
          <div class="yk-el-aside-title">
            <i class="wl-icon-zhishidian"></i>&nbsp;知识点
          </div>
          <div class="yk-qu-con"
               :class="{active: active == courseId}"
               @click="onAllQuesionChangeHandler(courseId)">
            <i class="wl-icon-xiaoyuan"></i>
            <div class="yk-title">全部</div>
            <div style='display:inline-block;width:30%;text-align:center'>
              <span class='yk-total'
                    style="color:#FFF;background:#409EFF;">{{totalCount}}</span>
            </div>
          </div>
          <div class="yk-qu-con"
               v-for="(item,index) in knowledgeLists"
               :key="item.Id"
               @click="onKnowledgeChangeHandler(item.Id,item.KnowledgeName)"
               :class="{active: active == item.Id}">
            <p class="point-span"
               :title="index"></p>
            <div class="yk-title"
                 :title="item.KnowledgeName">{{item.KnowledgeName}}</div>
            <span>{{item.questionCount}}</span>
            <p class="line-active">
            </p>
          </div>
          <div class="yk-qu-con"
               :class="{active: active == 'NotSet'}"
               @click="onAllQuesionChangeHandler(courseId,'NotSet')">
            <i class="wl-icon-xiaoyuan"></i>
            <div class="yk-title">未设置知识点</div>
            <span style="margin-left:6px;color:#FFF;background:#409EFF;">{{notsetCount}}</span>
            <p class="line-active">
            </p>
          </div>
          <div class="yk-add-group yk-add-group-question-add"
               @click="addGroup">
            <div v-if="addShow">
              <i class="el-icon-circle-plus-outline"></i>
              <span style='color:#409EFF;margin-left:7px'>添加知识点</span>
            </div>
            <el-input v-if="inShow"
                      v-model="knowledge"
                      placeholder="输入名称，按Enter确认"
                      @keyup.enter.native="newKnowledge"
                      @blur="addNewKnowledge"
                      class='confirm'></el-input>
          </div>
        </div>
      </div>
      <div style="padding-left:20px;"
           class="tea-question-main-wrapper">
        <div class="yk-dialogCon-new-a-addOrEdit">
          <div class="yk-choiceCon">
            <span class="sp-text-title" style='font-size:18px;color:#000;margin-top: 6px;float:left'>{{tisi}}</span>
            <div class="yk-add-group yk-add-group-select-color">
              <span class="knowledge">所属知识点：</span>
              <el-select v-model="valueEditor"
                         placeholder="知识点名称"
                         @change="addQueToKnowList">
                <el-option v-for="item in knowledgeLists"
                           :key="item.Id"
                           :label="item.KnowledgeName"
                           :value="item.Id">
                </el-option>
              </el-select>
            </div>
            <Choice ref="Choice"
                    :data.sync="editorQueData"
                    :valueEditor='valueEditor'
                    :childQuestionList='childQuestionList'
                    :showChoice='showChoice'
                    :checkDiffcult='checkDiffcult'
                    :courseId='courseId'
                    :stemFiles='stemFiles'
                    :analysisFile='analysisFile'
                    @newNodeEvent="savaQuestionInfo"
                    @done='refresh'
                    :showButton='showButton'></Choice>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Choice from "components/ObjectiveTest/ChoiceQuestion.vue";
import FillInTheBlanks from "components/ObjectiveTest/FillInTheBlanks.vue";
import Multiselect from "components/ObjectiveTest/Multiselect.vue";
import TrueFalse from "components/ObjectiveTest/TrueFalse.vue";
import ShortAnswer from "components/SubjectiveTest/ShortAnswer.vue";
import SynthesisInfo from "components/ObjectiveTest/SynthesisInfo.vue";
import {
  GetKnowledgeList,
  AddKnowledge
} from "api/v1.design.questionknowledge";
import { SaveQuestion, EditQuestion } from "api/v1.desgin.question";
export default {
  name: "QuestionWarehouseAdd",
  components: {
    Choice,
    TrueFalse,
    ShortAnswer,
    Multiselect,
    FillInTheBlanks,
    SynthesisInfo
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    questionId: {
      type: String,
      default: ""
    },
    knowledgeInfoId: {
      type: String,
      default: ""
    },
    showButton: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tisi: "添加题目",
      totalCount: 0,
      notsetCount: 0,
      addShow: true,
      inShow: false,
      active: "",
      queMainName: "",
      showChoice: false,
      inTestName: false,
      queDetailDialogVisible: false,
      ImportQueDialogVisible: false,
      knowledgeLists: [],
      type: ["", "单选题", "多选题", "判断题", "填空题", "简答题", "综合题"],
      selects: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      questionListDetail: [],
      checkDiffcult: "",
      knowledgeId: "",
      knowledge: "",
      knowledgeNew: "",
      valueEditor: "",
      editorQueData: null,
      // 详情
      questionInfo: {
        Difficulty: "",
        QuestionType: "",
        ContentText: "",
        Selects: Array,
        Answers: Array,
        Analysis: "",
        stemFiles: Array,
        analysisFiles: Array
      },
      childQuestionList: [],
      isNotset: "",
      // 题干附件
      stemFiles: [],
      // 解析附件
      analysisFile: [],
    };
  },
  computed: {
    auth() {
      let auth = this.$store.state.auth;
      return { ...auth };
    }
  },
  created() {
    console.log(this.auth);
    this.getKnowledgeList();
    if (this.questionId !== "") {
      this.tisi = "修改题目";
      EditQuestion(this.questionId).then(rst => {
        if (rst.code > 0) {
          this.valueEditor = rst.question.KnowledgeId;
          this.editorQueData = rst.question;
          this.childQuestionList = rst.subQuestionList;
          this.stemFiles = rst.stemFiles;
          this.analysisFile = rst.analysisFile;
          this.active = rst.question.KnowledgeId;
        } else {
          this.$message.warning(rst.msg);
        }
      });
    } else {
      this.valueEditor =
        this.knowledgeInfoId === this.courseId ||
        this.knowledgeInfoId === "NotSet"
          ? ""
          : this.knowledgeInfoId;
      this.active = this.knowledgeInfoId;
      this.knowledgeId = this.knowledgeInfoId;
    }
  },
  methods: {
    backtoclass() {
      this.$router.go(-1);
      // this.$router.push({
      //   name: "QuestionWarehouse",
      //   params: {
      //     courseId: this.courseId
      //   }
      // });
    },
    // 获取知识点
    getKnowledgeList: function() {
      this.questionListDetail = [];
      GetKnowledgeList(this.courseId).then(rst => {
        if (rst) {
          this.knowledgeLists = rst.knowledgeList;
          this.totalCount = rst.totalCount;
          this.notsetCount = rst.notsetCount;
          if (this.knowledgeId === "") {
            this.active = this.courseId;
            this.queMainName = "";
          }
        }
      });
    },
    // 刷新知识点
    RefreshKnowledge: function() {
      this.questionListDetail = [];
      GetKnowledgeList(this.courseId).then(rst => {
        if (rst) {
          this.knowledgeLists = rst.knowledgeList;
          this.totalCount = rst.totalCount;
          this.notsetCount = rst.notsetCount;
        }
      });
    },
    // 切换知识点
    onKnowledgeChangeHandler: function(id, name) {
      this.active = id;
      this.queMainName = name;
      this.valueEditor = id;
      this.knowledgeId = id;
      this.isNotset = "";
      this.knowledgeNew = this.queMainName;
      this.showTestName = true;
      this.inTestName = false;
      this.stemFiles = [];
      this.analysisFile = [];
    },
    onAllQuesionChangeHandler: function(id, type) {
      if (!type) {
        this.active = this.courseId;
        this.knowledgeId = "";
        this.queMainName = "";
        this.valueEditor = "";
        this.isNotset = "";
      } else {
        this.active = "NotSet";
        this.knowledgeId = "";
        this.queMainName = "";
        this.valueEditor = "";
        this.isNotset = "notset";
      }
    },
    // 新增知识点-回车
    newKnowledge: function() {
      if (this.knowledge === "") {
        this.addShow = true;
        this.inShow = false;
        this.knowledge = "";
        return false;
      }
      this.inShow = false;
      this.addShow = true;
    },
    // 新增知识点
    addKnowledge() {
      AddKnowledge(this.courseId, this.knowledge).then(rst => {
        if (rst.code === 1) {
          this.knowledge = "";
          this.RefreshKnowledge();
        }
      });
    },
    // 新增知识点-光标移除
    addNewKnowledge: function() {
      if (this.knowledge.trim() === "") {
        this.knowledge = "";
      } else {
        this.addKnowledge();
      }
      this.inShow = false;
      this.addShow = true;
    },
    addQueToKnowList: function(Id) {
      this.active = Id;
      this.valueEditor = Id;
    },
    clearp(str){
      debugger;
      return str.indexOf("<p>")>=0 ? str.slice(3,str.length-4) : str;
    },
    // 保存数据修改
    savaQuestionInfo: function(val) {
      var that = this;
      var correctAnswers = [];
      var list = [];
      debugger;
      if(val.quesType == 4){
        for(let i = 0; i< val.correctAnswers.length;i++){
          // val.correctAnswers[i].forEach(ele =>{
          //   list.push(that.clearp(ele));
          // });
           list = val.correctAnswers[i].map(that.clearp);
          console.log(list);
          correctAnswers.push(list.join('或'));
        }
        console.log(correctAnswers);

      }else{
        correctAnswers = val.correctAnswers;
      }
      SaveQuestion(
        this.courseId,
        this.valueEditor,
        val.quesType,
        val.diffcult,
        val.content,
        JSON.stringify(correctAnswers),
        val.analysis,
        JSON.stringify(val.selects),
        val.fileIds,
        val.analysisFileIds,
        val.questionId,
        val.answersIsDisorder
      ).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
          this.showChoice = false;
          this.RefreshKnowledge();
          if (this.active === "NotSet") {
            this.knowledgeId = "";
          }
          this.$refs.Choice.cleanData();
          if (!val.isAdd) {
            console.log(this.auth.userType);
            if (this.auth.userType == 2) {
                this.$router.push({
                name: "QuestionWarehouse",
                params: {
                  courseId: this.courseId
                }
              });
            } else {
              this.$router.push({
                name:"teaShareManagementQuestion",
                params: {
                  courseId: this.courseId
                }
              })
            }
            
          }
        } else {
          this.$message.warning(rst.msg);
        }
      });
    },
    addGroup: function() {
      this.addShow = false;
      this.inShow = true;
    },
    refresh(val) {}
  }
};
</script>

<style lang="scss">
.yk-qw-content-addOrEdit {
  padding: 20px 20px 20px 0;
  .yk-come-back-btn-wrapper {
    position: fixed;
    right: 53px;
    top: 10px;
    z-index: 2000;
    .yk-btn-new-back-s {
      padding: 2px 10px;
      .wl-icon-fanhui2 {
        font-size: 29px;
      }
    }
  }

  .yk-sourse-nemu-btn-wrapper-s {
    float: right;
    margin-left: 10px;
    margin-top: 5px;
    width: 90px;
    height: 32px;
    background: #3fa2ff;
    border-radius: 3px;
    line-height: 32px;
    text-align: center;
    color: #fff;
    .el-dropdown-link {
      font-size: 11px;
    }
  }
  .yk-source-menus {
    position: fixed;
    bottom: 40px;
    right: 40px;
    margin-top: -120px;
    z-index: 1060;
    width: 100px;
    text-align: center;
    a {
      display: block;
      height: 60px;
      text-align: center;
      border-bottom: 1px solid white;
      background-color: #409eff;
      line-height: 60px;
      text-decoration: none;
      color: white;
      font-size: 16px;
    }
    .fa-plus-circle {
      display: block;
      margin-top: 10px;
      color: #409eff;
      font-size: 50px;
      font-weight: bolder;
      cursor: pointer;
    }
    .menuFade-enter-active,
    .menuFade-leave-active {
      transition: all 0.2s;
    }
    .menuFade-enter,
    .menuFade-leave-to {
      transition: all 0.2s;
      transform: translateX(100%);
    }
    .linkActive {
      color: white;
      background-color: #19a580;
    }
  }

  .tea-quesiton-ware-content-addOrEdit {
    position: relative;
    .tea-question-side-wrapper {
      float: left;
      height: calc(100% - 50px);
      background: #fff;
      position: absolute;
      overflow-y: auto;
      top: -20px;
      border-right: 1px solid #ccc;
      .yk-el-aside {
        .yk-el-aside-title {
          background: #fff;
          color: #000;
          height: 50px;
          line-height: 50px;
          font-size: 18px;
          padding-left: 19px;
          span {
            margin-left: 5px;
          }
        }
        .yk-qu-con-header,
        .yk-qu-con-footer {
          position: relative;
          display: flex;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #f5f5f5;
          color: #000;
          cursor: pointer;
          position: relative;
          .yk-title {
            font-size: 16px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            width: 175px;
            color: #000;
          }
          &:hover {
            .line-active {
              display: block;
            }
          }
          .wl-icon-xiaoyuan {
            font-size: 36px;
            color: #000;
          }
          span {
            float: right;
            height: 18px;
            background: #409eff;
            color: #fff;
            line-height: 18px;
            margin-top: 18px;
            padding: 0 5px;
            border-radius: 9px;
          }
        }
        .yk-qu-con {
          position: relative;
          display: flex;
          height: 50px;
          line-height: 50px;
          color: #000;
          cursor: pointer;
          position: relative;
          .yk-title {
            font-size: 16px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            width: 158px;
            color: #000;
          }
          &:hover {
            .line-active {
              display: block;
            }
          }
          .wl-icon-xiaoyuan {
            font-size: 36px;
            color: #000;
          }
          span {
            float: right;
            height: 18px;
            border: 1px solid #409eff;
            color: #409eff;
            line-height: 17px;
            margin-top: 18px;
            margin-right: 20px;
            padding: 0 5px;
            border-radius: 9px;
          }
          .point-span {
            display: inline-block;
            width: 8px;
            height: 8px;
            border: 1px solid #fff;
            border-radius: 50%;
            margin: 20px 10px 0 34px;
          }
        }
        .active {
          background-color: rgb(221, 228, 235);
          // border-left:3px solid #409EFF;
          .line-active {
            display: block;
          }
        }
        .line-active {
          background-color: #409eff;
          position: absolute;
          height: 100%;
          width: 3px;
          top: 0px;
          left: -1px;
          display: none;
        }
        .yk-add-group {
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #fff;
          font-size: 17px;
          color: #009688;
          i {
            font-weight: bolder;
            color: #409eff;
          }
          .el-input.is-active .el-input__inner,
          .el-input__inner:focus {
            border-color: rgb(64, 158, 255);
          }
          .el-input {
            width: 80%;
          }
        }
      }
      .confirm {
        .el-input__inner {
          color: #000;
          background: #fff;
          border: 1px solid rgb(64, 158, 255);
        }
      }
    }
    .tea-question-main-wrapper {
      float: right;
      padding-left: 20px;
      width: calc(100% - 261px);
      // border: 1px solid #d7d7d7;
      border-left: none;
      .yk-main-head {
        border-bottom: 1px solid #4f6280;
        margin-bottom: 20px;
        .yk-que-name {
          display: flex;
          float: left;
          font-size: 20px;
          .el-dropdown {
            .el-dropdown-link {
              color: white;
              font-size: 20px;
            }
          }
          .test-name {
            margin-right: 10px;
          }
          i:hover {
            cursor: pointer;
          }
          i {
            margin-left: 10px;
          }
          span p {
            font-size: 20px;
          }
        }
        .yk-que-config {
          float: right;
          .el-form {
            float: left;
            .el-form-item {
              margin-bottom: 15px;
              .el-form-item__label {
                color: #000;
                padding: 0 0 0 4px;
              }
              .el-form-item__content {
                .el-input__inner {
                  padding-left: 10px;
                  color: #333;
                }
              }
            }
          }
        }
        .yk-que-config:after {
          content: "";
          clear: both;
          height: 0;
          visibility: hidden;
          display: block;
        }
        &:after {
          display: block;
          height: 0px;
          content: "";
          clear: both;
        }
      }
    }
  }
  .yk-dialogCon-new-a-addOrEdit {
    overflow: auto;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: #fff;
    .yk-choiceCon {
      width: 100%;
      padding: 10px;
      border-radius: 10px;
      background-color: #fff;
      position: relative;
      box-sizing: border-box;
      .yk-add-group {
        position: absolute;
        right: 370px;
        top: 2px;
        .knowledge {
          color: #000;
          font-size: 16px;
        }
        .el-select {
          .el-input__inner {
            border: 1px solid #e6e6e6;
            color: #ccc;
            background: #fff;
          }
          .el-input .el-select__caret {
            color: #409eff;
          }
        }
        .el-icon-close {
          position: absolute;
          top: 10px;
          right: 10px;
          // color: white;
          font-size: 25px;
          font-weight: bolder;
          cursor: pointer;
        }
        .el-select__caret {
          line-height: 32px;
        }
      }
    }
    &.slide-enter-active,
    &.slide-leave-active {
      transition: all 0.4s;
      background-color: rgba(0, 0, 0, 0);
    }
    .el-input__inner {
      border: 1px solid #ccc;
    }
  }
  .yk-qw-content-new-addOrEdit {
    .el-input__inner {
      height: 36px;
      background: #fff;
      border: 1px solid #409eff;
      color: #000;
    }
  }
  .fr-command:hover {
    background-color: #409eff;
  }
}
</style>
